export enum CheckType {
  START_PROVIDER_SESSION = 0,
  END_PROVIDER_SESSION = 1,
  CANCEL_PROVIDER_SESSION = 2,
}
